<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="modal-article"
      ref="modal-article"
      body-class="position-static"
      centered
      size="lg"
      title="Thêm/Sửa bài viết"
      no-close-on-backdrop
      @shown="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-form-group label-for="category">
              <template v-slot:label>
                Chuyên mục <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Chuyên mục"
                rules="required"
              >
                <v-select
                  id="category"
                  v-model="initData.categoryId"
                  label="label"
                  :options="articleCategories"
                  :reduce="option => option.value"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-for="title">
              <template v-slot:label>
                Tiêu đề <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Tiêu đề"
                rules="required"
              >
                <b-form-input
                  id="title"
                  v-model="initData.name"
                  name="title"
                  placeholder="Title bài viết"
                  :state="getElementState(errors)"
                  aria-describedby="input-1-live-feedback"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-for="header">
              <template v-slot:label>
                Mô tả bài viết <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Mô tả bài viết"
                rules="required"
              >
                <b-form-textarea
                  id="header"
                  v-model="initData.header"
                  name="header"
                  placeholder="Mô tả bài viết"
                  rows="3"
                  max-rows="6"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Hình thu nhỏ"
              label-for="image"
            >
              <b-img
                height="400px"
                :src="urlThumb"
                alt="Hình thu nhỏ"
              />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-sm ml-1"
                @click="$refs.inputFileRef.$el.click()"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="UploadIcon" /> Tải lên
                </span>
              </b-button>
              <b-form-file
                ref="inputFileRef"
                accept="image/*"
                :hidden="true"
                plain
                @change="uploadFile"
              />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="danger"
                class="ml-1 btn-sm"
                @click="onDeleteAvatar"
              >
                <span class="text-nowrap text-right">
                  <feather-icon icon="TrashIcon" /> Xóa
                </span>
              </b-button>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Nội dung bài viết: "
              label-for="description"
            >
              <quill-editor
                v-model="initData.description"
                :options="editorOption"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <b-form-group
              label="Số thứ tự"
              label-for="status"
            >
              <b-form-input
                id="order_no"
                v-model="initData.orderNo"
                type="number"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <b-form-group
              label="Trạng thái"
              label-for="status"
            >
              <v-select
                id="status"
                v-model="initData.status"
                :options="optionsStatus"
                :reduce="option => option.value"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
            lg="4"
            xl="4"
          >
            <b-form-group class="mt-2">
              <b-form-checkbox
                id="checkbox-1"
                v-model="initData.highlight"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
              >
                Tin nổi bật
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('modal-article')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton, BCol, BRow, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BImg, BFormFile, BModal, BOverlay,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { STATUSES } from '@/const/status'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Ripple from 'vue-ripple-directive'
import { ApiCode } from '@/const/api'

export default {
  name: 'FormArticles',
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    BModal,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BCol,
    BRow,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormTextarea,
    BFormCheckbox,
    BImg,
    quillEditor,
  },
  props: {
    dataSendForm: {
      type: Object,
      default: () => ({
        id: null,
        name: '',
        header: '',
        description: '',
        highlight: '0',
        status: 1,
        orderNo: 1,
        categoryId: null,
        mediaId: null,
        mediaCode: '',
        isChangeThumb: false,
      }),
    },

    modalShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
      optionsStatus: [],
      initData: {
        id: null,
        name: '',
        header: '',
        description: '',
        highlight: '0',
        status: 1,
        orderNo: 1,
        categoryId: null,
        mediaId: null,
        mediaCode: '',
        isChangeThumb: false,
      },
      thumbnail: null,
      required,
      urlThumb: require('@/assets/images/default/img.png'),
      editorOption: {
        theme: 'snow',
      },
    }
  },
  computed: {
    ...mapGetters({
      articleCategories: 'dropdown/articleCategories',
    }),
  },
  methods: {
    // handle even
    ...mapActions({
      getArticleCategories: 'dropdown/getArticleCategories',
      getLinkFile: 'portalArticle/getLinkFile',
      createArticle: 'portalArticle/createArticles',
    }),
    onShow() {
      if (this.dataSendForm.id) {
        this.initData = { ...this.initData, ...this.dataSendForm }
      }

      if (this.articleCategories.length > 0 && !this.dataSendForm.categoryId) {
        this.initData.categoryId = this.articleCategories[0].value
      }

      this.optionsStatus = STATUSES.map(item => ({
        value: item.value,
        label: item.label,
      }))
    },
    uploadFile(input) {
      if (input.target.files && input.target.files[0]) {
        const image = input.target.files[0]
        this.thumbnail = image
        this.initData.isChangeThumb = true

        const reader = new FileReader()
        reader.onload = e => {
          this.urlThumb = e.target.result
        }
        reader.readAsDataURL(image)
      }
    },

    async onSave(type = null) {
      const formData = new FormData()
      formData.append('file', this.thumbnail)
      console.log(JSON.stringify(this.initData))
      formData.append('article', new Blob(
        [JSON.stringify(this.initData)],
        { type: 'application/json' },
      ))

      this.isLoading = true
      try {
        const res = await this.createArticle(formData)
        if (res.code === ApiCode.SUCCESS) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          if (type === 'hide') {
            this.$bvModal.hide('modal-article')
          }
          this.$emit('succeed')
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.message,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    showToast(title, icon, variant, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          text,
        },
      })
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    onDeleteAvatar() {
      this.urlThumb = require('@/assets/images/default/img.png')
      this.thumbnail = null
      this.$refs.inputFileRef.reset()
      this.initData.isChangeThumb = true
    },
    onHide() {
      this.initData = {
        id: null,
        name: '',
        header: '',
        description: '',
        highlight: '0',
        status: 1,
        orderNo: 1,
        categoryId: null,
        mediaId: null,
        mediaCode: '',
      }
      this.thumbnail = null
      this.initData.isChangeThumb = false
    },
  },
}
</script>
